import React from 'react';
import Checkbox from 'components/Checkbox';
import ListItem from 'modules/Media/components/ListItem';

import { components } from 'apiTyped/types';
import {
  usePostRemoveTagMutation,
  usePostSetFavoriteMutation,
  usePostSetReadMutation
} from 'apiTyped/hooks/post.mutations';

const isMobile = window.innerWidth < 845;

type ArticleProps = {
  article: components['schemas']['Post'];
  isSelected: boolean;
  // eslint-disable-next-line no-unused-vars
  onCheckBoxClick: (id: number) => void;
  // eslint-disable-next-line no-unused-vars
  onAddTagClick: (id: number) => void;
  // eslint-disable-next-line no-unused-vars
  onFavoriteClick: (id: number) => void;
  // eslint-disable-next-line no-unused-vars
  onReadClick: (id: number) => void;
  // eslint-disable-next-line no-unused-vars
  onShareClick: (id: number) => void;
  handleTagSubmit: (
    // eslint-disable-next-line no-unused-vars
    selectedArticlesIds: number[],
    // eslint-disable-next-line no-unused-vars
    tagsToAdd: ({ id: number; name: string } | undefined)[],
    // eslint-disable-next-line no-unused-vars
    tagsToRemove: ({ id: number; name: string } | undefined)[]
  ) => void;
};

const Article = ({
  article,
  isSelected,
  onCheckBoxClick,
  onAddTagClick,
  onFavoriteClick,
  onReadClick,
  onShareClick,
  handleTagSubmit
}: ArticleProps) => {
  const { mutate: setRead } = usePostSetReadMutation(article.id);
  const { mutateAsync: removeTag } = usePostRemoveTagMutation(article.id);
  const { mutate: setFavorite } = usePostSetFavoriteMutation(article.id);

  const onDeleteClick = async (
    tag: { id: number; name: string },
    articleId: number
  ) => {
    const deletedTag = await removeTag(tag);
    handleTagSubmit([articleId], [], [deletedTag]);
  };

  const handleClickFavorite = (articleId: number) => {
    setFavorite();
    onFavoriteClick(articleId);
  };

  const handleClickRead = (articleId: number) => {
    setRead();
    onReadClick(articleId);
  };

  return (
    <div className="boxItem" key={`list-article-${article.id}`}>
      {!isMobile && (
        <div className="checkboxItem">
          <Checkbox
            style={null}
            styleDisabled={null}
            disabled={null}
            onChange={() => onCheckBoxClick(article.id)}
            checked={isSelected}
          />
        </div>
      )}
      <ListItem
        {...article}
        selected={isSelected}
        toggleFavorite={handleClickFavorite}
        handleTagsModal={() => onAddTagClick(article.id)}
        toggleRead={handleClickRead}
        handleTagsSubmit={onDeleteClick}
        onShareClick={onShareClick}
      />
    </div>
  );
};

export default Article;
